import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const price = 6.39;
  return <section id="oferta" className="py-24 bg-[#F2E8DA]/50 backdrop-blur-[2px]" data-id="element-172">
      <div className="container mx-auto px-6" data-id="element-173">
        <motion.div className="max-w-xl mx-auto bg-white/90 backdrop-blur-sm rounded-3xl p-10 md:p-14 shadow-soft-xl text-center border border-beige relative overflow-hidden" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-174">
          {/* Decorative top border */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-sage via-terracotta to-sage" data-id="element-175"></div>

          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-text-dark mb-8" data-id="element-176">
            Empieza hoy mismo
          </h2>

          <div className="mb-4 inline-block bg-terracotta/10 px-5 py-1.5 rounded-full" data-id="element-177">
            <span className="text-base text-text-medium font-medium" data-id="element-178">
              Antes{' '}
              <span className="line-through text-text-medium/60" data-id="element-179">$47</span>
            </span>
          </div>

          <div className="mb-8 flex flex-col items-center justify-center" data-id="element-180">
            <span className="text-lg text-text-medium mb-2 uppercase tracking-wide font-semibold" data-id="element-181">
              Hoy por solo
            </span>
            <div className="flex flex-col items-center" data-id="element-182">
              <span className="text-6xl md:text-7xl font-heading font-bold text-terracotta leading-none" data-id="element-183">
                ${price.toFixed(2)}
              </span>
            </div>
          </div>

          <div className="mb-10 inline-block bg-beige-light px-4 py-2 rounded-full" data-id="element-184">
            <p className="text-sm font-medium text-olive flex items-center" data-id="element-185">
              <span className="w-2 h-2 rounded-full bg-terracotta mr-2 animate-pulse" data-id="element-186"></span>
              Acceso inmediato al comprar
            </p>
          </div>

          <div className="w-full mb-8" data-id="element-187">
            <CTAButton text="Comprar ahora" variant="primary" className="w-full sm:w-auto min-w-[240px]" onClick={() => {
            trackAddToCart();
            sessionStorage.setItem('selectedBumps', JSON.stringify({
              bump1: false,
              bump2: false
            }));
            window.location.hash = 'upsell';
          }} data-id="element-188" />
          </div>

          {/* Garantía de confianza */}
          <div className="border-t border-beige pt-6" data-id="element-189">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-190">
              <span className="text-2xl" data-id="element-191">🛡️</span>
              <span className="font-heading font-semibold text-text-dark text-lg" data-id="element-192">
                Garantía de 7 días
              </span>
            </div>
            <p className="text-sm text-text-medium max-w-sm mx-auto leading-relaxed" data-id="element-193">
              Si dentro de los primeros 7 días sientes que esta guía no es para
              ti, te devolvemos el 100% de tu dinero. Sin preguntas, sin
              complicaciones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}